/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Po_Issue_Not_A_ReductionInputs */

const en_po_issue_not_a_reduction = /** @type {(inputs: Po_Issue_Not_A_ReductionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`must be lower than the quantity ordered`)
};

/**
* | output |
* | --- |
* | "must be lower than the quantity ordered" |
*
* @param {Po_Issue_Not_A_ReductionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const po_issue_not_a_reduction = /** @type {((inputs?: Po_Issue_Not_A_ReductionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Po_Issue_Not_A_ReductionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_po_issue_not_a_reduction(inputs)
});